import React, { ChangeEvent, useEffect, useState } from 'react';

import { Button, Modal } from '@/components';
import { TextInput } from '@/components/text-input';
import { useUserUpdate } from '@/hooks';
import { useTranslation } from 'react-i18next';

import styles from './Modals.module.css';

export interface formDataType {
  first_name: string;
  last_name: string;
  phone: string;
}

interface UserInfoModalProps {
  onNext: (res: Api.UserObject) => void;
  userInfo: formDataType;
}

function UserInfoModal({ onNext, userInfo }: UserInfoModalProps) {
  const [formData, setFormData] = useState<formDataType>({
    first_name: '',
    last_name: '',
    phone: ''
  });
  const { mutate, isLoading } = useUserUpdate({
    ...formData,
    send_phone_verification_sms: false,
    onSuccess: (res) => {
      if (res && (res as Api.UserObject).user_id) {
        onNext(res as Api.UserObject);
      }
    }
  });
  const { t } = useTranslation();

  useEffect(() => {
    setFormData(userInfo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const updateUser = () => {
    mutate();
  };

  return (
    <Modal closeButton={false} modalStyles={{ maxWidth: '480px' }}>
      <div className={styles.welcomeModal}>
        <h2 className={styles.welcomeModalTitle}>{t('inviteView.userInfoModal.title')}</h2>

        <div className={styles.welcomeModalBody}>
          <TextInput
            label={t('signup.name')}
            value={formData.first_name}
            name="first_name"
            required
            placeholder={t('placeholder.firstName')}
            onChange={handleChange}
          />
          <TextInput
            label={t('signup.surName')}
            value={formData.last_name}
            name="last_name"
            required
            placeholder={t('placeholder.lastName')}
            onChange={handleChange}
          />
          <TextInput
            label={t('signup.phoneNumber')}
            value={formData.phone}
            name="phone"
            required
            placeholder={t('placeholder.phone')}
            onChange={handleChange}
          />
        </div>

        <div className={styles.welcomeModalButton}>
          <Button
            theme="cta"
            isLoading={isLoading}
            disabled={!formData.first_name || !formData.last_name || !formData.phone}
            onClick={updateUser}
          >
            {t('inviteView.userInfoModal.button')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default UserInfoModal;
